__turbopack_context__.v({
  "className": "inter_2f569732-module__qJAgJG__className",
  "variable": "inter_2f569732-module__qJAgJG__variable",
});
